"use strict";
import React from "react";
import { successIcon } from "../icons";
export function Notification(props) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-component": "Notification",
      className: "v3__notification v3__notification--inline v3__notification--success"
    },
    /* @__PURE__ */ React.createElement("span", { className: "v3__notification-icon v3__notification-icon--inline" }, successIcon()),
    /* @__PURE__ */ React.createElement("div", { className: "v3__notification-text v3__notification-text--column" }, props.title && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "v3__notification-text-title",
        style: { display: "flex" }
      },
      /* @__PURE__ */ React.createElement("span", null, props.title)
    ), /* @__PURE__ */ React.createElement("span", { className: "v3__notification-text-message" }, props.message)),
    props.action
  );
}
